import { PropsWithChildren } from 'react';

import { AppContext } from './app-context';
import { useAppProvider } from './useAppProvider';

export function AppProvider(props: PropsWithChildren) {
  const values = useAppProvider();
  return <AppContext.Provider value={values}>{props.children}</AppContext.Provider>;
}
